import { Button } from "components/atoms/Button";
import { BuildingIcon, ToolIcon, WarningCountIcon } from "components/atoms/Icon";
import { useBuildingModelUid } from "hooks/useBuildingModelUid";
import { usePermissions } from "hooks/usePermissions";
import { useBuildingModelHeaderQuery } from "queries/useBuildingModelHeaderQuery";
import { useMemo } from "react";
import useBuildingSidebarState from "recoilStore/CustomPlan/useBuildingSidebarState";
import { UserPermissions } from "utils/enums";
import { getDataCoverageWarnings } from "utils/helpers";
import BuildingHeaderLoading from "./BuildingHeaderLoading";
import DeleteBuilding from "./DeleteBuilding";

function BuildingHeaderActionsError() {
    const { hasPermission } = usePermissions();
    const buildingModelUid = useBuildingModelUid();

    const { data: buildingModelHeader, isLoading } = useBuildingModelHeaderQuery(buildingModelUid);

    const { state: sidebarState, setState: setSidebarState } = useBuildingSidebarState();

    const dataCoverageWarnings = useMemo(
        () =>
            buildingModelHeader?.dataCoverage ? getDataCoverageWarnings(buildingModelHeader.dataCoverage) : undefined,
        [buildingModelHeader]
    );

    const hasEquipmentSizeAndYearCount =
        buildingModelHeader?.dataCoverage.equipmentDataHasSizeAndYear === false &&
        buildingModelHeader?.dataCoverage.equipmentDataUploaded
            ? 1
            : 0;

    const warningCount = dataCoverageWarnings
        ? Object.values(dataCoverageWarnings).filter(Boolean).length + hasEquipmentSizeAndYearCount
        : 0;

    if (isLoading || !buildingModelHeader) return <BuildingHeaderLoading />;

    return (
        <div className="baseline-building-report-header__menu-items">
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    width: "max-content",
                }}
            >
                {hasPermission(UserPermissions.UseInternalTools) && (
                    <Button
                        type="secondary"
                        onClick={() => {
                            window.location.href = `/sandbox/building/${buildingModelUid}${window.location.search}`;
                        }}
                        icon={<ToolIcon color="black" />}
                        id="sandbox-button"
                    >
                        Sandbox
                    </Button>
                )}
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                    }}
                >
                    <Button
                        type="secondary"
                        onClick={() =>
                            setSidebarState({
                                ...sidebarState,
                                isSidebarOpen: true,
                            })
                        }
                        icon={<BuildingIcon />}
                        id="building-profile-button"
                    >
                        Profile
                    </Button>
                    {warningCount > 0 && (
                        <WarningCountIcon
                            style={{
                                position: "absolute",
                                top: "-8px",
                                right: "-8px",
                            }}
                        />
                    )}
                </div>
            </div>
            <DeleteBuilding buildingModelUid={buildingModelUid} buildingName={buildingModelHeader.buildingName} />
        </div>
    );
}

export default BuildingHeaderActionsError;
